import React from "react";

const items = [
  "Guarantee Convertible Bonds",
  "Merkle Tree Ledger",
  "Inter-ERP Commerce",
  "IoT Audit Automation",
  "Customer Leads Engine",
  "Software IP · Stockholm",
];

export const Marquee = () => {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <section
      className="relative border-y border-white/10 bg-white/[0.02] overflow-hidden py-6"
      data-testid="marquee-section"
      aria-label="marquee"
    >
      <div className="flex whitespace-nowrap marquee-track">
        {doubled.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-6 px-8 font-mono text-sm md:text-base uppercase tracking-[0.3em] text-white/50"
          >
            <span className="text-spectrum-green">◈</span>
            {t}
          </span>
        ))}
      </div>
    </section>
  );
};
